import React from 'react';
import PropTypes from "prop-types";

export default class OutsourceChartLegend extends React.Component {

  renderData(){
    if (!this.props.data){
      return null;
    }
    return this.props.data.map((object, i) => {
      return (<span key={i}><span className="badge-state" style={{ backgroundColor: '#' + object.color }}></span>{object.name}</span>);
    });
  }

  render() {
    return (
      <div className="chart-key">
        {this.renderData()}
      </div>
    );
  }

}

OutsourceChartLegend.propTypes = {
  data: PropTypes.array,
};

OutsourceChartLegend.defaultProps = {
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/OutsourceChartLegend.js